import React from 'react';
import { useTranslation } from 'react-i18next';
import { KPI } from '@heroui-pro/react/kpi';
import { KPIGroup } from '@heroui-pro/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { IMPORT_FIGURE_LABEL_KEY, type ImportFigure } from './importStatsMeta';

type ImportFiguresProps = {
    figures: ImportFigure[];
    /** A phone: the figures stack instead of sharing a row. */
    isNarrow: boolean;
};

/**
 * A row of the import's figures as HeroUI Pro KPIs (a `dt` title over a `dd`
 * value each), divided by the group's separators; stacked on a phone. The
 * value is printed the app's way (`text`): a `NumberValue` render prop, as
 * the Purchases summary does (BOS-162).
 */
export const ImportFigures: React.FC<ImportFiguresProps> = ({
    figures,
    isNarrow,
}) => {
    const { t } = useTranslation('pages');

    return (
        <KPIGroup orientation={isNarrow ? 'vertical' : 'horizontal'}>
            {figures.map((figure, index) => (
                <React.Fragment key={figure.key}>
                    {index > 0 ? <KPIGroup.Separator /> : null}
                    <KPI
                        {...getNodeTestIdProp(
                            `catalog-import-result-figure-${figure.key}`,
                        )}
                    >
                        <KPI.Header>
                            <KPI.Title>
                                {t(IMPORT_FIGURE_LABEL_KEY[figure.key])}
                            </KPI.Title>
                        </KPI.Header>
                        <KPI.Content>
                            <KPI.Value value={figure.value}>
                                {() => figure.text}
                            </KPI.Value>
                        </KPI.Content>
                    </KPI>
                </React.Fragment>
            ))}
        </KPIGroup>
    );
};
